/**
 * This module is included as part of the `yarn build:css` build process and changes to it will affect the output of `stylesheet.compiled.ts`.
 * You must run `yarn build:css` after any changes here as the build will fail if `stylesheet.compiled.ts` changes on CI.
 */

const space = {
  1: "0.25rem",
  2: "0.5rem",
  3: "1rem",
  4: "1.5rem",
  5: "2rem",
  6: "2.5rem",
  7: "3rem",
  8: "3.5rem",
  9: "4rem",
  10: "4.5rem",
} as const;

const borderColor = {
  base: "#f1f1f1",
} as const;

const borderWidth = {
  base: "2px",
  thin: "1px",
} as const;

const borderRadius = {
  base: "3px",
  large: "5px",
} as const;

const border = {
  base: `${borderWidth.base} solid ${borderColor.base}`,
  inline: `${borderWidth.thin} solid ${borderColor.base}`,
} as const;

const boxShadow = {
  base: "0px 1px 2px rgba(3, 27, 78, 0.16), 0px 1px 3px rgba(3, 27, 78, 0.2)",
  raised: "0px 2px 4px rgba(3, 27, 78, 0.1), 0px 4px 4px rgba(3, 27, 78, 0.16)",
  top: "0px 12px 15px rgba(3, 27, 78, 0.1), 0px 19px 38px rgba(3, 27, 78, 0.16)",
} as const;

const whitespace = {
  large: "32px",
  medium: "24px",
  regular: "16px",
  small: "8px",
  xlarge: "64px",
  xsmall: "4px",
} as const;

const fontSize = {
  base: "16px",
  larger: "24px",
  large: "20px",
  small: "14px",
  code: "14px",
  xsmall: "11px",
} as const;

const fontWeight = {
  base: "400",
  bold: "600",
  bolder: "700",
  light: "300",
} as const;

const headingFontRules = {
  "2xl": {
    fontSize: "3rem",
    lineHeight: "1.25",
  },
  xl: {
    fontSize: "2rem",
    lineHeight: "1.25",
  },
  lg: {
    fontSize: "1.5rem",
    lineHeight: "1.25",
  },
  md: {
    fontSize: "1.125rem",
    lineHeight: "1.25",
  },
  sm: {
    fontSize: "1rem",
    lineHeight: "1.5",
  },
  xs: {
    fontSize: "0.875rem",
    lineHeight: "1.5",
  },
} as const;

const transitionSpeed = {
  base: "0.25s",
  long: "0.4s",
} as const;

const zIndex = {
  negative: "-1",
  base: "1",
  override: "4",
  raised: "2",
  top: "3",
} as const;

const height = {
  base: "48px",
  button: "44px",
  small: "40px",
  xsmall: "24px",
} as const;

const dropdown = {
  maxHeight: "300px",
  width: "20rem",
} as const;

const code = {
  fontFamily: "'Operator Mono', Consolas, monospace, serif",
  background: "#fafafa",
} as const;

export const vars = {
  easeInOutCubic: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  fontColor: "#333",
  bodyFont: '"Proxima Nova", "proxima-nova", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
  monoFont: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
  lineHeight: "1.5",
  disabledOpacity: "0.5",

  border,
  borderColor,
  borderRadius,
  borderWidth,
  boxShadow,
  code,
  dropdown,
  fontSize,
  fontWeight,
  headingFontRules,
  height,
  space,
  transitionSpeed,
  whitespace,
  zIndex,
} as const;
